(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var body = document.body;
    if (!body.classList.contains('stilloak-home')) {
      return;
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = document.querySelectorAll('.stilloak-home .reveal');

    if (!reducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('visible');
      });
    }

    var header = document.querySelector('.site-header');
    var heroShape = document.querySelector('.hero-bg-shape');
    var heroCircle = document.querySelector('.hero-bg-circle');
    var ticking = false;

    function onScroll() {
      if (header) {
        header.classList.toggle('scrolled', window.scrollY > 50);
      }

      if (reducedMotion || !heroShape || ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        var scrollY = window.pageYOffset;
        if (scrollY < window.innerHeight) {
          heroShape.style.transform = 'translateY(' + scrollY * 0.12 + 'px)';
          if (heroCircle) {
            heroCircle.style.transform = 'translateY(' + scrollY * 0.06 + 'px)';
          }
        }
        ticking = false;
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = document.querySelector('.mobile-toggle');
    var menu = document.querySelector('.mobile-menu');
    var overlay = document.querySelector('.mobile-overlay');
    var menuClose = document.querySelector('.mobile-menu-close');

    if (toggle && menu && overlay) {
      function closeMenu() {
        toggle.classList.remove('active');
        menu.classList.remove('open');
        overlay.classList.remove('open');
        body.classList.remove('menu-open');
      }

      function openMenu() {
        toggle.classList.add('active');
        menu.classList.add('open');
        overlay.classList.add('open');
        body.classList.add('menu-open');
      }

      toggle.addEventListener('click', function () {
        if (toggle.classList.contains('active')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      if (menuClose) {
        menuClose.addEventListener('click', closeMenu);
      }

      overlay.addEventListener('click', closeMenu);
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 992) {
          closeMenu();
        }
      });
    }

    // Mobile carousels with dot indicators
    function initCarousels() {
      if (window.innerWidth >= 768) return;

      var carousels = [
        { grid: '.features-grid', item: '.feature-item', dotsCount: 2 },
        { grid: '.why-grid', item: '.why-card', dotsCount: 0 },
        { grid: '.testimonials-grid', item: '.testimonial-card', dotsCount: 0 },
        { grid: '.process-grid', item: '.process-step', dotsCount: 0 }
      ];

      carousels.forEach(function (cfg) {
        var grid = document.querySelector('.stilloak-home ' + cfg.grid);
        if (!grid || grid.dataset.carousel === 'true') return;
        var items = grid.querySelectorAll(cfg.item);
        if (items.length <= 1) return;

        grid.dataset.carousel = 'true';

        var wrapper = document.createElement('div');
        wrapper.className = 'mobile-carousel-wrapper';
        grid.parentNode.insertBefore(wrapper, grid);
        wrapper.appendChild(grid);

        var numDots = cfg.dotsCount > 0 ? cfg.dotsCount : items.length;

        var dots = document.createElement('div');
        dots.className = 'carousel-dots';
        for (var i = 0; i < numDots; i++) {
          var dot = document.createElement('button');
          dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.dataset.index = i;
          (function (idx) {
            dot.addEventListener('click', function () {
              items[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            });
          })(i);
          dots.appendChild(dot);
        }
        wrapper.appendChild(dots);

        var allDots = dots.querySelectorAll('.carousel-dot');
        grid.addEventListener('scroll', function () {
          var scrollLeft = grid.scrollLeft;
          var gap = 12;
          var itemWidth = items[0].offsetWidth + gap;
          var activeIdx = Math.round(scrollLeft / itemWidth);
          if (activeIdx >= numDots) activeIdx = numDots - 1;
          allDots.forEach(function (d, idx) {
            d.classList.toggle('active', idx === activeIdx);
          });
        }, { passive: true });
      });
    }

    initCarousels();
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) {
        document.querySelectorAll('.mobile-carousel-wrapper').forEach(function (w) {
          var grid = w.querySelector('[data-carousel]');
          if (grid) {
            w.parentNode.insertBefore(grid, w);
            w.remove();
            grid.dataset.carousel = '';
          }
        });
      } else {
        initCarousels();
      }
    });

    // Reviews bar slider (mobile)
    var reviewsSlider = document.querySelector('[data-reviews-slider]');
    if (reviewsSlider) {
      var track = reviewsSlider.querySelector('.header-reviews-bar-inner');
      var prevBtn = reviewsSlider.querySelector('.reviews-slider-prev');
      var nextBtn = reviewsSlider.querySelector('.reviews-slider-next');
      var reviewItems = track ? track.querySelectorAll('.header-review-item') : [];
      var reviewIndex = 0;
      var reviewCount = reviewItems.length;

      function slideReviewTo(index) {
        if (index < 0) index = 0;
        if (index >= reviewCount) index = reviewCount - 1;
        reviewIndex = index;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        prevBtn.style.opacity = index === 0 ? '.3' : '1';
        nextBtn.style.opacity = index === reviewCount - 1 ? '.3' : '1';
      }

      if (prevBtn && nextBtn && reviewCount > 1) {
        prevBtn.addEventListener('click', function () { slideReviewTo(reviewIndex - 1); });
        nextBtn.addEventListener('click', function () { slideReviewTo(reviewIndex + 1); });
        slideReviewTo(0);
      }
    }
  });
})();
